import { createSlice } from '@reduxjs/toolkit';
import { getFechaDesdeAsync } from './Actions';

export interface FechaDesdeState {
  status: 'idle' | 'loading' | 'failed';
  fecha: string | null;
  errorMessage: string;
}

const initialState: FechaDesdeState = {
  status: 'idle',
  fecha: null,
  errorMessage: '',
};

export const fechaDesdeSlice = createSlice({
  name: 'fechaDesde',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getFechaDesdeAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getFechaDesdeAsync.rejected, (state, action: any) => {
        state.status = 'failed';
        state.fecha = null;
        state.errorMessage = action.payload?.errorMessage ?? 'Error al obtener la fecha desde';
      })
      .addCase(getFechaDesdeAsync.fulfilled, (state, action: any) => {
        state.status = 'idle';
        state.fecha = action.payload?.fechaDesdeMinima ?? null;
        state.errorMessage = '';
      });
  },
});

export default fechaDesdeSlice.reducer;
